import { useState } from "react";
import { X } from "lucide-react";

const FIELDS = [["rsi_threshold", "RSI buy threshold"], ["volume_multiple", "Volume multiple"], ["stop_loss", "Stop-loss %"], ["target", "Target %"]];

export const StrategyModal = ({ initial, onClose, onSave }) => {
  const [s, setS] = useState(initial); const [error, setError] = useState("");
  const save = async () => { try { await onSave(s); onClose(); } catch (e) { setError(e.message); } };
  return <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}><div className="settings-modal" data-testid="strategy-settings-modal">
    <button className="modal-close" data-testid="settings-modal-close" onClick={onClose}><X size={16} /></button>
    <div className="eyebrow">STRATEGY BUILDER</div><h2>Signal settings</h2>
    <p>EMA 9/21 crossover confirmed by RSI and VWAP. Target and stop-loss set the dotted lines on the charts.</p>
    <label className="field">Candle interval
      <select data-testid="strategy-interval-input" value={s.interval} onChange={e => setS({ ...s, interval: e.target.value })}>{["1m", "5m", "15m"].map(v => <option key={v}>{v}</option>)}</select>
    </label>
    {FIELDS.map(([key, label]) => <label key={key} className="field">{label}<input data-testid={`strategy-${key}-input`} type="number" step="0.1" value={s[key]} onChange={e => setS({ ...s, [key]: Number(e.target.value) })} /></label>)}
    {error && <div className="form-error" data-testid="strategy-save-error">{error}</div>}
    <button className="confirm-btn" data-testid="save-strategy-button" onClick={save}>Save strategy</button>
  </div></div>;
};
